import api from "../services/api";

export const loadEndpointWithPagination = async (endpoint, sizeReceived) => {
  let page = 1;
  let size = sizeReceived || 50;
  let allResults = [];
  let hasMore = true;

  while (hasMore) {
    const response = await api.get(`${endpoint}?page=${page}&size=${size}`);
    const { data, totalPages } = response.data.response;

    if (page > totalPages) break;

    allResults = allResults?.concat(data);
    hasMore = data?.length === size;
    page++;
  };

  return allResults;
}